/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../../http/http';
import { success, error } from '../../../../../services/alert-message';

const urlApi = 'central/api/v1/consultas';

/**
*
* @param {*} param0
*/
export async function consultaHistoricoList({ commit }, obj) {
  Loading.show();
  return (await http.get(`${urlApi}?${obj.page}&include=servico`) // filter[consultaAtiva]=1&
    .then(res => {
      Loading.hide();
      // commit('SET_CONSULTAS_ATIVAR', res.data);
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
